import axios from 'axios';
import { useNavigate } from 'react-router';
import { apiURL } from '../constants/apiUrlConstants';
const axiosClient = axios.create();
const UNAUTHORIZED = 401;
// Add a request interceptor
axiosClient.interceptors.request.use(
  config => {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
      // config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['Content-Type'] = 'application/json';
    // config.headers['Accept'] = 'application/json';  // Add this line
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosClient.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response || {};
    if (status === UNAUTHORIZED) {
      clearSessionStorage();
    }
    return Promise.reject(error)
  }
);


//   error => {
//     return Promise.reject(error);
//   }
// );

// // Add a response interceptor
// axiosClient.interceptors.response.use(
//   response => response,
//   error => {
//     const { status } = error.response || {};
//     if (status === UNAUTHORIZED) {
//       clearSessionStorage();
//     }
//     return Promise.reject(error);
//   }
// );

export function getRequest(URL: any) {
  return axiosClient.get(`${URL}`).then(response => response);
}

export function getRequestWithParam(URL: string, payload: any) {
  return axiosClient.get(URL, { params: payload }).then(response => response);
}

export function postRequest(URL: any, payload: any) {
  return axiosClient.post(`${URL}`, payload).then(response => response);
}

// export function postRequestWithParams(URL: any, payload: any) {
//   return axiosClient.post(`${URL}`, payload).then(response => response);
// }

export function patchRequest(URL: any, payload: any) {
  return axiosClient.patch(`${URL}`, payload).then(response => response);
}
export function deleteRequest(URL: any) {
  return axiosClient.delete(`${URL}`).then(response => response);
}
export function clearSessionStorage() {
  sessionStorage.removeItem("accessToken");
  sessionStorage.removeItem('civilId');
  sessionStorage.removeItem("isEmail");
  sessionStorage.removeItem('name');
  sessionStorage.removeItem('nameArabic');
  // sessionStorage.removeItem('orderNo');
  // sessionStorage.removeItem('sessionId');
  // sessionStorage.removeItem('referenceNumber');
}
export async function getNewToken() {
  const civilId = sessionStorage.getItem('civilId');
  const response = await postRequest(
    process.env.REACT_APP_API_URL + apiURL.GET_TOKEN,
    { civilId }
  );
  if (response == null) {
    clearSessionStorage();
    return;
  }
  if (response.status === 401) {
    clearSessionStorage();
    return;
  }
  if (response.status === 200) {
    const data = response.data;
    sessionStorage.setItem("accessToken", data);
  }
}